import { addDays, format, startOfWeek } from 'date-fns';
import { DefaultOpeningHours, OpeningHourExceptions, Store } from '../global-state/types';
import { getStoreOperationHours } from '../utils';
import { useUser } from './useController';

export const useStoreOpeningHours = () => {
  const {
    get: { currentStoreId, stores },
  } = useUser();

  const getStoreOpeningHours = (currentDate: Date) => {
    const getStoreData = stores.find((store) => store.storeId === currentStoreId);

    const { openingHour, closingHour } = getStoreOperationHours(currentDate, getStoreData?.openingHours);

    return { storeOpeningHour: openingHour, storeClosingHour: closingHour };
  };

  const getWeeklyOpeningHours = (storeData: Store) => {
    const storeDefaultOpeningHours: DefaultOpeningHours = JSON.parse(JSON.stringify(storeData.openingHours));
    const storeOpeningHoursExceptions: OpeningHourExceptions = JSON.parse(
      JSON.stringify(storeData.openingHourExceptions),
    );

    const weekDataArray = Array.from({ length: 7 }, (_, i) => {
      const currentDate = addDays(startOfWeek(new Date()), i);
      const formattedDate = format(currentDate, 'yyyy-MM-dd');
      const dayKey = format(currentDate, 'eee').toLowerCase();

      return {
        day: dayKey,
        date: formattedDate,
        exceptions: storeOpeningHoursExceptions?.item?.find((item) => item.date === formattedDate),
        defaultOpeningHours: storeDefaultOpeningHours[dayKey],
      };
    });

    return weekDataArray;
  };

  return { getStoreOpeningHours, getWeeklyOpeningHours };
};
